<template>
  <router-view></router-view>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'CourseBook',
  beforeRouteUpdate(to, from, next) {
    if (!this.courseContent) {
      this.fetchCourseContent({ id: to.params.courseBookId })
    }
    next()
  },
  beforeDestroy() {
    this.setCourseContent({})
  },
  computed: {
    ...mapGetters({
      courseContent: 'education/getCourseContent'
    })
  },
  methods: {
    ...mapActions({
      fetchCourseContent: 'education/fetchCourseContent'
    }),
    ...mapMutations({
      setCourseContent: 'education/setCourseContent'
    })
  }
}
</script>

<style scoped>

</style>
